import Vue from "vue";
import { runXinrenlijinCreate } from "@/script/xinrenlijinCreateRunner";

// 新人礼金页面状态（表单/进度放 Vuex，切换菜单不丢失）
const state = {
    xr_form: {
        participate_type: 1, // 1.指定商品 2.全店商品
        title_mode: "default", // default.默认名称 prefix.自定义前缀
        title_prefix: "",
        promo_mode: "amount", // amount.立减金额 discount.折扣
        float_on: true, // 浮动面额开关
        avg_amount: 2, // 平均优惠金额(元,整数) 浮动开启时用
        max_amount: 3, // 最高优惠金额(元,整数) 浮动开启时用
        amount: 2, // 优惠金额(元) 浮动关闭时用
        avg_discount: 9.0, // 商品平均折扣 浮动开启时用
        max_discount: 8.9, // 最高商品折扣 浮动开启时用
        discount: 9.0, // 商品折扣 浮动关闭时用
        per_activity_num: 50, // 单活动包含商品个数 1-500
    },
    xr_selected_shop_ids: [],
    xr_date_range: null, // [startMs, endMs]

    // 指定商品-商品加载
    xr_products: [], // 可创建商品
    xr_invalid_products: [], // 不可创建商品 {row, reason, source}
    xr_product_selects: [], // 勾选的 _key 列表
    xr_load_running: false,
    xr_load_status_text: "",
    xr_load_stop_flag: false,
    xr_loaded_once: false, // 加载过一次后，改动优惠设置才提示重新加载
    xr_promo_dirty: false, // 优惠设置在加载后被改动过

    // 全店商品-店铺校验 { [shopId]: {checking, pass, reason, total, amount} }
    xr_shop_check: {},

    // 创建进度
    xr_create_running: false,
    xr_create_stop_requested: false,
    xr_create_dialog: false,
    xr_create_total: 0,
    xr_create_done: 0,
    xr_create_success: 0,
    xr_create_fail: 0,
    xr_create_results: [],

    // 活动管理
    xr_manage_rows: [],
    xr_manage_loading: false,
    xr_manage_stop_flag: false,
    xr_manage_page_info: "",
};

const mutations = {
    setXrForm(state, patch) {
        Object.assign(state.xr_form, patch || {});
    },
    setXrSelectedShopIds(state, ids) {
        state.xr_selected_shop_ids = ids || [];
    },
    setXrDateRange(state, range) {
        state.xr_date_range = range;
    },
    setXrProducts(state, rows) {
        state.xr_products = rows || [];
    },
    appendXrProducts(state, rows) {
        if (Array.isArray(rows) && rows.length) {
            state.xr_products = state.xr_products.concat(rows);
        }
    },
    setXrInvalidProducts(state, rows) {
        state.xr_invalid_products = rows || [];
    },
    appendXrInvalidProducts(state, rows) {
        if (Array.isArray(rows) && rows.length) {
            state.xr_invalid_products = state.xr_invalid_products.concat(rows);
        }
    },
    setXrProductSelects(state, keys) {
        state.xr_product_selects = keys || [];
    },
    xrPatchProduct(state, { _key, patch }) {
        const row = state.xr_products.find((r) => r._key === _key);
        if (row && patch) Object.assign(row, patch);
    },
    setXrLoadRunning(state, v) {
        state.xr_load_running = !!v;
    },
    setXrLoadStatusText(state, v) {
        state.xr_load_status_text = v || "";
    },
    setXrLoadStopFlag(state, v) {
        state.xr_load_stop_flag = !!v;
    },
    setXrLoadedOnce(state, v) {
        state.xr_loaded_once = !!v;
    },
    setXrPromoDirty(state, v) {
        state.xr_promo_dirty = !!v;
    },
    setXrShopCheckOne(state, { shopId, patch }) {
        const key = String(shopId);
        const old = state.xr_shop_check[key] || {};
        Vue.set(state.xr_shop_check, key, Object.assign({}, old, patch));
    },
    removeXrShopCheck(state, shopId) {
        Vue.delete(state.xr_shop_check, String(shopId));
    },
    setXrCreateRunning(state, v) {
        state.xr_create_running = !!v;
    },
    setXrCreateStopRequested(state, v) {
        state.xr_create_stop_requested = !!v;
    },
    setXrCreateDialog(state, v) {
        state.xr_create_dialog = !!v;
    },
    xrCreateStart(state, total) {
        state.xr_create_total = total;
        state.xr_create_done = 0;
        state.xr_create_success = 0;
        state.xr_create_fail = 0;
        state.xr_create_results = [];
    },
    xrCreateProgress(state, { done = 0, success = 0, fail = 0 }) {
        state.xr_create_done += done;
        state.xr_create_success += success;
        state.xr_create_fail += fail;
    },
    xrCreateResultPush(state, rows) {
        if (Array.isArray(rows) && rows.length) {
            const base = state.xr_create_results.length;
            const stamped = rows.map((r, i) => ({
                _rowId: `xrres_${Date.now()}_${base + i}_${Math.random()
                    .toString(36)
                    .slice(2, 8)}`,
                ...r,
            }));
            state.xr_create_results = state.xr_create_results.concat(stamped);
        }
    },
    setXrManageRows(state, rows) {
        state.xr_manage_rows = rows || [];
    },
    appendXrManageRows(state, rows) {
        if (Array.isArray(rows) && rows.length) {
            state.xr_manage_rows = state.xr_manage_rows.concat(rows);
        }
    },
    xrManagePatchRow(state, { _rowId, patch }) {
        const row = state.xr_manage_rows.find((r) => r._rowId === _rowId);
        if (row && patch) Object.assign(row, patch);
    },
    setXrManageLoading(state, v) {
        state.xr_manage_loading = !!v;
    },
    setXrManageStopFlag(state, v) {
        state.xr_manage_stop_flag = !!v;
    },
    setXrManagePageInfo(state, v) {
        state.xr_manage_page_info = v || "";
    },
};

const actions = {
    // 创建新人礼金活动（指定商品/全店商品），进度写入 state
    async xrRunCreate({ state, commit }, { shopList }) {
        if (state.xr_create_running) return;
        commit("setXrCreateRunning", true);
        commit("setXrCreateStopRequested", false);
        commit("setXrCreateDialog", true);
        try {
            await runXinrenlijinCreate({ state, commit, shopList });
        } finally {
            commit("setXrCreateRunning", false);
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
